import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './surveyCodeSection.css'
import { useUserStore } from '../../../store/userStore'
import { getTestCodeAndCompletionApi, saveTestCompletionApi } from '../../../api/survey'
import Swal from 'sweetalert2'
import { swalAlert, swalErrorAlert } from '../../../utils/swal/swal'

const surveyDoneStyle = {
    padding: "2rem 1.5rem",
    border: "1px solid rgb(229, 229, 229)",
    borderRadius: "0.375rem",
}

const SurveyCodeSection = () => {
    /* zustand */
    const { userInfo } = useUserStore((state) => state)

    /* State */
    // 발급된 코드
    const [sltCode, setSltCode] = useState('')
    const [mciCode, setMciCode] = useState('')

    // 검사완료 여부
    const [sltCompletion, setSltCompletion] = useState(false)
    const [mciCompletion, setMciCompletion] = useState(false)

    // isLoading
    const [isLoading, setIsLoading] = useState(false)


    /* UseEffect */
    useEffect(() => {
        getTestStatus()
    }, [])


    /* Methods */
    const getTestStatus = async () => {
        const userId = userInfo?.user_id
        if (!userId) return

        try {
            setIsLoading(true)
            const response = await getTestCodeAndCompletionApi(userId)

            if (response.data.code === 200) {
                const resData = response.data.resData
                // Set Code
                resData?.slt_code ? setSltCode(resData?.slt_code) : setSltCode('')
                resData?.mci_code ? setMciCode(resData?.mci_code) : setMciCode('')

                // Set Completion
                resData?.slt_completion ? setSltCompletion(true) : setSltCompletion(false)
                resData?.mci_completion ? setMciCompletion(true) : setMciCompletion(false)
            }
            else {
                // Set Code
                setSltCode('')
                setMciCode('')

                // Set Completion
                setSltCompletion(false)
                setMciCompletion(false)
            }
            setIsLoading(false)

        } catch (error) {
            setIsLoading(false)
            swalErrorAlert(
                "조회 실패",
                "코드 조회 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.",
                "error",
                "확인"
            )
        }
    }

    const onClickTestCompletion = async (testType) => {
        if (isLoading) return;

        const userId = userInfo?.user_id
        if (!userId) return

        if (testType === 'slt') {
            if (sltCompletion) return
            if (!sltCode) {
                swalAlert('', "온라인 심리 검사를 수행한 후 다시 시도해주세요.", "warning", "확인")
                return
            }

        } else if (testType === 'mci') {
            if (mciCompletion) return
            if (!mciCode) {
                swalAlert('', "온라인 심리 검사를 수행한 후 다시 시도해주세요.", "warning", "확인")
                return
            }
        } else return

        setIsLoading(true)
        Swal.fire({
            title: '',
            html: '완료상태는 되돌릴 수 없습니다.<br/> 온라인 심리 검사를 완료하셨습니까?',
            icon: 'question',
            showCancelButton: true, // 취소 버튼 표시
            confirmButtonText: '확인',
            confirmButtonColor: "",
            cancelButtonText: '취소',
            reverseButtons: true, // 버튼 순서 변경
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Api
                try {
                    const reqData = { testType, userId }
                    const response = await saveTestCompletionApi(reqData)
                    if (response.data.code === 200) {
                        testType === 'slt' ? setSltCompletion(true) : setMciCompletion(true)
                        setIsLoading(false)
                        return
                    }
                    else if (response.data.code === 204) {
                        // No Data
                        testType === 'slt' ? setSltCompletion(false) : setMciCompletion(false)
                        setIsLoading(false)
                        swalAlert("처리 실패", "온라인 심리 검사를 수행한 후 다시 시도해주세요.", "error", "확인")
                        return
                    } else return

                } catch (error) {
                    // console.log(error);
                    testType === 'slt' ? setSltCompletion(false) : setMciCompletion(false)
                    setIsLoading(false)
                    swalErrorAlert("처리 실패", "완료 처리 도중 에러가 발생했습니다.<br> 에러가 반복되면 관리자에게 문의해 주세요.", "error", "확인")
                    return
                }
            }
            else {
                setIsLoading(false)
                return
            }
        })
    }

    return (
        <>
            <div className='mb-5'>
                <h3 className='h3 mb-3'>온라인 심리 검사 실시 인증 코드</h3>

                <div className='survey-code-section'>
                    <div className='survey-code-row'>
                        <div className='survey-code-name'>SLT 코드</div>
                        <div className='survey-code-code'>{sltCode ? sltCode : '코드가 발급되지 않았습니다.'}</div>
                        <div className='survey-code-button'>
                            <button type='button' className={sltCompletion ? 'active' : ''} onClick={() => onClickTestCompletion('slt')}>SLT 검사완료</button>
                        </div>
                    </div>

                    <div className='survey-code-row'>
                        <div className='survey-code-name'>MCI 코드</div>
                        <div className='survey-code-code'>{mciCode ? mciCode : '코드가 발급되지 않았습니다.'}</div>
                        <div className='survey-code-button'>
                            <button type='button' className={mciCompletion ? 'active' : ''} onClick={() => onClickTestCompletion('mci')}>MCI 검사완료</button>
                        </div>
                    </div>
                </div>
            </div>

            {(sltCompletion && mciCompletion) &&
                <div className='lh-lg text-center' style={surveyDoneStyle}>
                    <p>모든 검사를 완료하였습니다.</p>
                    <p><Link to='/survey/report' className='text-primary'>보고서 확인 페이지</Link> 에서 보고서를 확인하세요.</p>
                    <p>(보고서 발급까지 최대 일주일 정도 소요됩니다.)</p>
                </div>
            }
        </>
    )
}

export default SurveyCodeSection